import React from "react";
import {
  deleteAllBasket,
  deleteOneItemBasket,
  sendMailRequest,
  additionAllSum,
  plusNumberOfItem,
  minusNumberOfItem,
  addFile,
  getAllSum,
  getBasket,
  // getDeliveryDate,
  getFile,
} from "../../redux/Calc_reducer";
import { connect } from "react-redux";
import BasketItem from "./BasketItem";
import { Link } from "react-scroll";
import BasketForm from "./BasketForm";
import { formValueSelector } from "redux-form";
import PersonalForm from "./PersonalForm";
import { messageChatErase } from "../../redux/Chat_reducer";

const selector = formValueSelector("basketDelivery");

const Basket = (props) => {
  const {
    deleteAllBasket,
    deleteOneItemBasket,
    sendMailRequest,
    additionAllSum,
    basket,
    plusNumberOfItem,
    minusNumberOfItem,
    allSum,
    hasDelivery,
    hasDeliveryAddress,
    hasComment,
    // deliveryDate,
    messageChatErase,
    file,
    addFile,
  } = props;

  const setActiveModal = () => {
    props.setModal(<PersonalForm
      handleSubmit={(e: React.FormEvent) => {
        e.preventDefault();
        const values = {
          fio: e.target["fio"].value,
          // email: e.target["email"].value,
          phone: e.target["phone"].value,
        };
        sendMail(values);
      }}
    />);
    messageChatErase("");
  };

  const prepareData = {
    file,
    basket,
    delivery: hasDelivery,
    deliveryAddress: hasDeliveryAddress,
    allSum,
    comment:hasComment,
    // deliveryDate,
  };
  const disabledOrder = !(
    /*!!deliveryDate &&*/
    (hasDelivery === "Самовывоз" || !!hasDeliveryAddress)
  );
  const sendMail = async (values) => {
    await Object.assign(prepareData, values);
    await sendMailRequest(prepareData);
  };
  const add = (e) => {
    addFile(e.target.files[0]);
  };
  const isEmpty = (obj: File) => {
    return !obj?.name;
  };

  React.useEffect(() => {
    const objMoney = {
      basket,
      hasDelivery,
    };
    additionAllSum(objMoney);
  }, [basket, hasDelivery, additionAllSum]);

  return (
    <div className="block_basket" id="basket">
      <div className="basket_title_box">
        <div className="basket_title">КОРЗИНА ЗАКАЗОВ</div>
        <div className="basket_btn_clear_box">
          <button
            onClick={() => deleteAllBasket()}
            className="basket_btn_clear"
          >
            <div className="basket_btn_clear_text_box">ОЧИСТИТЬ КОРЗИНУ</div>
          </button>
        </div>
      </div>
      <div className="basket_description_box">
        <div className="basket_description_item basket_description_item_1">
          <span>Товар</span>
        </div>
        <div className="basket_description_item basket_description_item_2">
          Цена
        </div>
        <div className="basket_description_item basket_description_item_3">
          Количество
        </div>
        <div className="basket_description_item basket_description_item_4">
          Стоимость
        </div>
      </div>
      <div className="basket_product_box">
        <div className="basketFlex">
          {basket.map((el, i) => {
            return (
              <BasketItem
                plus={plusNumberOfItem}
                minus={minusNumberOfItem}
                deleteItem={(element) => {
                  deleteOneItemBasket(element);
                }}
                key={i}
                el={el}
              />
            );
          })}
          <div className="input__wrapper">
            <input
              onInput={add}
              className="input_file"
              id="upload-file__input_1"
              type="file"
              multiple
              accept="image/png, image/jpeg,.pdf,.word,.docx"
            />
            <label
              className="upload-file__label"
              htmlFor="upload-file__input_1"
            >
              <div className="upload_text_box">
                  {!isEmpty(file) ? "Чертеж добавлен" : "Добавить чертеж"}
              </div>
              <div className="upload_svg_box">
                {!isEmpty(file) ? (
                  <svg
                    className="upload-file__icon"
                    width="30px"
                    height="30px"
                    fill="#41cbdd"
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>ionicons-v5-l</title>
                    <path
                      d="M400,48H112a64.07,64.07,0,0,0-64,64V400a64.07,64.07,0,0,0,64,64H400a64.07,64.07,0,0,0,64-64V112A64.07,64.07,0,0,0,400,48ZM364.25,186.29l-134.4,160a16,16,0,0,1-12,5.71h-.27a16,16,0,0,1-11.89-5.3l-57.6-64a16,16,0,1,1,23.78-21.4l45.29,50.32L339.75,165.71a16,16,0,0,1,24.5,20.58Z"/>
                  </svg>
                ) : (
                  <svg
                    className="upload-file__icon"
                    width="30px"
                    height="30px"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="#C1C1C1"
                      d="M286 384h-80c-14.2 1-23-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c11.6 11.6 3.7 33.1-13.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-23-23V366c0-13.3 10.7-24 24-24h136v8c0 31 24.3 56 56 56h80c30.9 0 55-26.1 57-55v-8h135c13.3 0 24 10.6 24 24zm-124 88c0-11-9-20-19-20s-19 9-20 20 9 19 20 20 21-9 20-20zm64 0c0-12-9-20-20-20s-20 9-19 20 9 20 20 20 21-9 20-20z"
                    ></path>
                  </svg>
                )}
              </div>
            </label>
          </div>
        </div>
      </div>
      <BasketForm/>
      <div className="basket_footer_box">
        <div className="basket_footer_box_left">
          <div className="basket_footer_item_box">
            <button
              disabled={disabledOrder}
              onClick={() => {
                setActiveModal();
              }}
              className="basket_footer_btn"
            >
              <div className="basket_btn_checkout_text_box">ОФОРМИТЬ ЗАКАЗ</div>
            </button>
          </div>
          <div className="basket_footer_item_box">
            <Link
              className="basket_btn_continue_text_box"
              to={"calculator"}
              offset={-65}
              smooth={true}
              duration={800}
            >
              <button className="basket_footer_btn basket_footer_btn_continue">
                ПРОДОЛЖИТЬ ПОКУПКИ
              </button>
            </Link>
          </div>
        </div>
        <div className="basket_footer_box_right">
          <div className="basket_footer_item_box">
            <div className="basket_footer_item_box basket_footer_item_box_text">
              <div className="basket_footer_text">ИТОГО:</div>
              <div className="basket_footer_text basket_footer_price">
                {" "}
                {allSum}
              </div>
              <div className="basket_footer_text basket_footer_rub">₽</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mstp = (state) => ({
  basket: getBasket(state),
  allSum: getAllSum(state),
  hasDelivery: selector(state, "delivery"),
  hasDeliveryAddress: selector(state, "deliveryAddress"),
  hasComment: selector(state, "comment"),
  file: getFile(state),
  // deliveryDate: getDeliveryDate(state),
});

const mdtp = (dispatch) => ({
  deleteAllBasket: (p) => dispatch(deleteAllBasket(p)),
  deleteOneItemBasket: (p) => dispatch(deleteOneItemBasket(p)),
  sendMailRequest: (p) => dispatch(sendMailRequest(p)),
  plusNumberOfItem: (p) => dispatch(plusNumberOfItem(p)),
  minusNumberOfItem: (p) => dispatch(minusNumberOfItem(p)),
  additionAllSum: (p) => dispatch(additionAllSum(p)),
  messageChatErase: (p) => dispatch(messageChatErase(p)),
  addFile: (p) => dispatch(addFile(p)),
});

export default connect(mstp, mdtp)(Basket);
